import React, { useReducer } from 'react';
import ModeloContext from './modeloContext';
import ModeloReducer from './modeloReducer';

import clienteAxios from '../../service/axios';

import { 
    OBTENER_MODELOS,
    AGREGAR_MODELO,
    ELIMINAR_MODELO,
    ACTUALIZAR_MODELO,
    MODELO_ERROR,
    MODELO_OK,
    MODELO_ACTUAL,
    OBTENER_MODELO,
    SET_HOST
} from 'types/context';

const ModeloState = props => {
    const initialState = {
        host: "",
        modelos : [], // grupos del cliente
        modelo: null,
        cliente: null,
        formulario : false,
        errorformulario: false,        
        mensaje: null,
        alerta:""
    }

    const [ state, dispatch ] = useReducer(ModeloReducer, initialState);
    
    const host = process.env.REACT_APP_BACKEND_URL || 'https://app.dev.pampa4.ar:4000/'
    const obtenerModelos = async (marcaId, indice) => {
        
        try {
            // siempre deberia venir un cliente
            let resultado = await clienteAxios.get(`/modelos?marcaId=${marcaId}`,{
                    params: {
                        desde: indice? indice :1,
                        limite: 10,
                    },
                });            
            //
            const modelos = []

            if (resultado?.data?.modelos?.rows != null) {
                resultado.data.modelos.rows.map(modelo => {
                    modelos.push({
                        ...modelo,
                        logo: host + modelo.file?.path
                    })
                })
            }

            dispatch({
                type: OBTENER_MODELOS,
                payload: modelos
            });

            dispatch({
                type: SET_HOST,
                payload: host
            });

            return modelos           
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }            
            dispatch({
                type: MODELO_ERROR,
                payload: alerta
            })
        }
    }

    // Agregar nuevo grupo
    const agregarModelo = async (modelo) => {
        try {
            const resultado = await clienteAxios.post('/modelos',modelo);
            
            // Insertar el grupo en el estado
            dispatch({
                type: AGREGAR_MODELO,
                payload: resultado.data.modeloDB
            })
            const alerta = {
                msg: "Modelo agregada con exito",
                categoria: 'exito'
            }
            dispatch({
                type: MODELO_OK,
                payload: alerta
            })
            return resultado.status
        } catch (error) {
            console.log(error.response)
            const alerta = {
                msg: error.response.data.msg,
                categoria: 'error'
            }
            
            dispatch({
                type: MODELO_ERROR,
                payload: alerta
            })
            return alerta
        }
    }
    // Selecciona el grupo que el usuario dio click
    const modeloActual = modeloId => {
        dispatch({
            type: MODELO_ACTUAL,
            payload: modeloId
        })
    }

    // Elimina una modelo
    const eliminarModelo = async modeloId => {
        try {
            await clienteAxios.delete(`/modelos/${modeloId}`);
            dispatch({
                type: ELIMINAR_MODELO,
                payload: modeloId
            })
            const alerta = {
                msg: "Modelo eliminado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: MODELO_OK,
                payload: alerta
            })
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            
            dispatch({
                type: MODELO_ERROR,
                payload: alerta
            })
        }
    }

    // Aactualizar grupo
    const actualizarModelo = async modelo => {
        const imagen = modelo.base64File

        try {
            const resultado = await  clienteAxios.put(`/modelos/${modelo.id}`,{
                ...modelo,
                imagen: imagen? imagen : undefined
            })
            // Actualizo el disp en el state
            dispatch({
                type: ACTUALIZAR_MODELO,
                payload: resultado.data.modelo
            })
            const alerta = {
                msg: "Modelo editado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: MODELO_OK,
                payload: alerta
            })
            return resultado.status 
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            
            dispatch({
                type: MODELO_ERROR,
                payload: alerta
            })
            return alerta
        }
    }

    // muestra un error de validacion
    const errorModelo = (msj,categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }            
        dispatch({
            type: MODELO_ERROR,
            payload: alerta
        })
    }
    const OkModelo = (msj,categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }            
        dispatch({
            type: MODELO_OK,
            payload: alerta
        })
    }
    const clearErrorModelo = () => {
        dispatch({
            type: MODELO_ERROR,
            payload: null,
        });
        };

    const clearOkModelo = () => {
        dispatch({
            type: MODELO_OK,
            payload: null,
        });
    };

    // Obtengo un grupo por id
    const obtenerModelo = async (modeloId) => {
        const tempArr = []
        let tempModelo
        try {
            
            const resultado = await clienteAxios.get(`/modelo/${modeloId}`);                   
            
            dispatch({
                type: OBTENER_MODELO,
                payload: tempModelo
            })
            return resultado.data.modelo;            
            
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }            
            dispatch({
                type: MODELO_ERROR,
                payload: alerta
            })
        }
    }

    return(
        <ModeloContext.Provider
            value={{
                host:state.host,
                modelos: state.modelos,
                modelo: state.modelo,
                cliente: state.cliente,
                formulario: state.formulario,
                errorformulario: state.errorformulario,                
                mensaje: state.mensaje,
                alerta:state.alerta,
                obtenerModelos,
                agregarModelo,
                modeloActual,
                clearErrorModelo,
                clearOkModelo,
                eliminarModelo,
                actualizarModelo,
                errorModelo,
                OkModelo,
                obtenerModelo,
            }}
        >{props.children}

        </ModeloContext.Provider>
    )
}
export default ModeloState;
